import React from 'react';
import { Box, TextField } from '@mui/material';
import ArgonTypography from 'components/ArgonTypography';
import ArgonSelect from 'components/ArgonSelect';
import { getLanguageOptions } from '../../constants/languages';

const LanguageInput = ({ 
  language, 
  name, 
  onLanguageChange, 
  onNameChange, 
  disabled = false,
  languageLabel = "Language",
  nameLabel = "Name",
  languagePlaceholder = "Select Language",
  namePlaceholder = "Enter name in this language"
}) => {
  return (
    <Box display="flex" gap={2} alignItems="flex-start">
      {/* Language Selection */}
      <Box flex={1}>
        <ArgonTypography variant="h6" fontWeight="bold" mb={1}>
          {languageLabel}
        </ArgonTypography>
        <ArgonSelect
          options={getLanguageOptions()}
          value={language}
          onChange={onLanguageChange}
          placeholder={languagePlaceholder}
          disable={disabled || true} // Always disabled since language is pre-selected
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "10px",
              backgroundColor: "#f8f9fa", // Slightly different background to show it's read-only
            },
            "& input::placeholder": {
              color: "#94A3B8",
              fontSize: 14,
            },
            "& .MuiInputBase-input": {
              fontSize: 14,
              fontWeight: 500,
              color: "#172a4d",
            },
          }}
        />
      </Box>

      {/* Name Input */}
      <Box flex={2}>
        <ArgonTypography variant="h6" fontWeight="bold" mb={1}>
          {nameLabel}
        </ArgonTypography>
        <TextField
          fullWidth
          value={name}
          onChange={onNameChange}
          placeholder={namePlaceholder}
          disabled={disabled}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "10px",
              backgroundColor: "#fff",
            },
            "& input::placeholder": {
              color: "#94A3B8",
              fontSize: 14,
            },
            "& .MuiInputBase-input": {
              fontSize: 14,
              fontWeight: 500,
              color: "#172a4d",
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default LanguageInput; 